import * as React from 'react'

const TrashIcon = (props: { className?: string }) => {
  return (
    <svg
      className={'icon ' + props.className}
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.916667 14.6667C0.916667 15.675 1.74167 16.5 2.75 16.5H10.0833C11.0917 16.5 11.9167 15.675 11.9167 14.6667V3.66667H0.916667V14.6667ZM12.8333 0.916667H9.625L8.70833 0H4.125L3.20833 0.916667H0V2.75H12.8333V0.916667Z'
        transform='translate(4.58301 3.66699)'
        fill='#666666'
      />
      <line y1='-0.5' x2='8.25' y2='-0.5' transform='translate(8.25 9.16699) rotate(90)' stroke='white' />
      <line y1='-0.5' x2='8.25' y2='-0.5' transform='translate(12.833 9.16699) rotate(90)' stroke='white' />
    </svg>
  )
}

export default TrashIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/Trash.tsx